var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [{ name: "ripple", rawName: "v-ripple" }],
      class: { selected: _vm.showSelected },
      attrs: { id: "ticketList" }
    },
    [
      _vm.unit
        ? [
            _c("div", { staticClass: "left" }, [
              _c("div", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm.unit.title))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "property" }, [
                _vm._v(
                  _vm._s(_vm.$store.getters.property(_vm.unit.property).name)
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "type" }, [
                _vm._v(_vm._s(_vm.$store.getters.unitType(_vm.unit.type).name))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "right" }, [
              _c("div", { staticClass: "icon" }, [
                _vm.unit.userCount > 1
                  ? _c("i", {
                      staticClass: "mdi mdi-24px mdi-account-multiple"
                    })
                  : _vm.unit.userCount === 1
                    ? _c("i", { staticClass: "mdi mdi-24px mdi-account" })
                    : _c("i", {
                        staticClass: "mdi mdi-24px mdi-account-off no-user"
                      })
              ])
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b76cb72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b76cb72","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UnitList.vue
// module id = 626
// module chunks = 4